import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["src", "alt", "margin", "display", "overlay", "withGrayscale", "withBlur", "constrain", "width", "height", "elementRef", "styles", "loading"];
var _dec, _dec2, _class, _Img;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { View } from '@instructure/ui-view';
import { passthroughProps } from '@instructure/ui-react-utils';
import { testable } from '@instructure/ui-testable';
import { withStyle } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { propTypes, allowedProps } from './props';
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/**
---
category: components
---
**/
let Img = (_dec = withStyle(generateStyle, generateComponentTheme), _dec2 = testable(), _dec(_class = _dec2(_class = (_Img = class Img extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
  }
  render() {
    const _this$props3 = this.props,
      src = _this$props3.src,
      alt = _this$props3.alt,
      margin = _this$props3.margin,
      display = _this$props3.display,
      overlay = _this$props3.overlay,
      withGrayscale = _this$props3.withGrayscale,
      withBlur = _this$props3.withBlur,
      constrain = _this$props3.constrain,
      width = _this$props3.width,
      height = _this$props3.height,
      elementRef = _this$props3.elementRef,
      styles = _this$props3.styles,
      loading = _this$props3.loading,
      props = _objectWithoutProperties(_this$props3, _excluded);
    const a11yProps = {
      alt: alt || ''
    };
    const imageProps = {
      css: styles === null || styles === void 0 ? void 0 : styles.img,
      src,
      loading
    };
    const containerProps = {
      ...passthroughProps(props),
      width,
      height,
      margin,
      display,
      elementRef: this.handleRef
    };
    if (overlay) {
      // if a background image is rendered we add the a11y props on the container element
      const rootProps = {
        ...containerProps
      };
      return _jsxs(View, {
        ...rootProps,
        as: "span",
        css: styles === null || styles === void 0 ? void 0 : styles.container,
        children: [_jsx("img", {
          ...imageProps,
          ...a11yProps
        }), overlay && _jsx("span", {
          css: styles === null || styles === void 0 ? void 0 : styles.overlay
        })]
      });
    } else {
      return _jsx(View, {
        ...containerProps,
        ...imageProps,
        ...a11yProps,
        as: "img"
      });
    }
  }
}, _Img.displayName = "Img", _Img.componentId = 'Img', _Img.propTypes = propTypes, _Img.allowedProps = allowedProps, _Img.defaultProps = {
  alt: '',
  display: 'inline-block',
  withGrayscale: false,
  withBlur: false
}, _Img)) || _class) || _class);
export default Img;
export { Img };